import React, { useState, useEffect } from "react";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import { fetchProfile } from "../../../Services/ApiTestService/aadharTestService";
import { verifyDL } from "../../../Services/ApiTestService/apiTestService";
import { InputWithLabel, Button } from "../../../Components/Tags/Tags";
import { FiCheckCircle } from 'react-icons/fi';
import Loader from "../../../Loader";
import { Data7 } from "../Data";
import { Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { useService } from "../../../context/ServiceContext";


const DLVerify = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [dlData, setDlData] = useState({});
  const [errors, setErrors] = useState({});
  const [profileData, setProfileData] = useState({});
  const [idNumber, setIdNumber] = useState("");
  const [dob, setDob] = useState("");
  const { serviceName } = useService();

  // Fetch profile data on mount
  useEffect(() => { 
    const fetchProfileData = async () => {
      try {
        setIsLoading(true);
        const response = await fetchProfile();
        setProfileData(response.data);
      } catch (error) {
        console.error("Error fetching profile data:", error);
        showErrorToast("Failed to fetch profile data.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchProfileData();
  }, []);

  // Form validation
  const validateForm = (idNumber, dob) => {
    const errors = {};
  
    // DL number must be 2 letters + 13 digits = 15 characters
    const dlRegex = /^[A-Z]{2}[0-9]{13}$/;
  
    if (!idNumber.trim()) {
      errors.idNumber = "Driving License number is required.";
    } else if (!dlRegex.test(idNumber.toUpperCase())) {
      errors.idNumber = "DL number must be 2 letters followed by 13 digits (e.g., BR0420270023150).";
    }
  
    if (!dob.trim()) {
      errors.dob = "Date of Birth is required.";
    }
  
    return errors;
  };
  
  
  
  const handleSubmit = async () => {
    const validationErrors = validateForm(idNumber,dob);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) return;

    try {
      setIsLoading(true);

      const response = await verifyDL({
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        id_number: idNumber,
        dob: dob
      });


      const statusCode = response?.status?.code || response?.status;
      if (statusCode === 200) {
        const dlData = response?.data;


        // ✅ Check if valid object or array
        if (dlData && (typeof dlData === "object" || Array.isArray(dlData))) {
            setDlData(dlData);
          showSuccessToast(response.status?.message || "License No. Verified successfully.");

          // Clear form
          setIdNumber("");
          setDob("");
          setErrors({});
        } else {
          showErrorToast("License No. are missing or in an unexpected format.");
        }
      } else if (statusCode === 422) {
        const backendErrors = response.data.message || {};

        showErrorToast(response.data.message || "Invalid format or data.");
    } else if (statusCode === 500) {
     const errorMessage = response.data.message || response?.message || "Server error occurred";
         showErrorToast(errorMessage);
      }
       else {
        
        showErrorToast(response.status?.message || response.message || response.data.message || response.error.message || `Unexpected error occurred (code: ${statusCode})`);
      }     
    } catch (error) {
      console.error("GST Details Error:", error);
      showErrorToast("Failed to verify Mobile  details. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Seo />
      {isLoading && <Loader />}
      <Header heading={serviceName} />

      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 justify-center md:ml-80 ml-0 p-4">
        
        
      <div className="col-span-2 md:col-span-6 flex justify-end">
  <Link
    to="/TestMaster"
    className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-1 py-1 rounded-md font-semibold shadow-md transition duration-300"
  >
    <span>Go Back</span>
    <IoArrowBackCircleOutline size={24} />
  </Link>
</div>

        
        <InputWithLabel
          type="text"
          label="License Number"
          placeholder="Enter License Number"
          maxLength=""
          className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
          name="id_number"
          id="id_number"
          required={true}
          value={idNumber}
          onChange={(e) => setIdNumber(e.target.value)}
          error={errors.idNumber}
        />

<InputWithLabel
          type="date"
          label="Select DOB"
          className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
          name="dob"
          id="dob"
          required={true}
          value={dob}
          onChange={(e) => setDob(e.target.value)}
          error={errors.dobNumber}
        />

        <div>
          <Button
            type="button"
            className="text-center text-white bg-blue-900 shadow-lg bg-gradient-to-r from-blue-400 via-blue-1200 to-blue-900 font-semibold rounded-md px-2 py-1 mt-5 text-md hover:from-blue-900 hover:to-blue-400 border-4 ms-2"
            id="verifyDL"
            name="verifyDL"
            text="Verify"
            onClick={handleSubmit}
          />
        </div>
      </div>

     
      {dlData &&
  typeof dlData === "object" &&
  dlData.license_number &&
  dlData.dob && 
  (
    <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-2 px-2">

<div className="bg-gradient-to-r from-blue-600 to-blue-200 overflow-y-auto max-h-[520px] border-2 border-blue-600 rounded-xl shadow-2xl p-2 w-full max-w-sm mx-auto  hover:shadow-3xl">
<div className="text-center mb-1">
    <h3 className="text-white text-lg font-bold tracking-wide underline">Driving License</h3>
  </div>
  <div className="flex justify-center mb-1">
    {/* Profile Image */}
    {dlData?.profile_image ? (
      <img
        src={`data:image/jpeg;base64,${dlData.profile_image}`}
        alt="Profile"
        className="w-32 h-32 rounded-full object-cover border-2 border-white shadow-lg transform transition-all duration-300 hover:scale-105"
      />
    ) : (
      <div className="w-32 h-32 rounded-full bg-gray-300 flex items-center justify-center text-gray-500 border-4 border-white shadow-lg transform transition-all duration-300 hover:scale-105">
        No Image
      </div>
    )}
  </div>

  <div className="space-y-1 text-white text-md">
    <p><strong>Name:</strong> {dlData?.name || "N/A"}</p>
    <p><strong>Gender:</strong> {dlData?.gender || "N/A"}</p>
    <p><strong>DOB:</strong> {dlData?.dob || "N/A"}</p>
    <p><strong>Blood Group:</strong> {dlData?.blood_group || "N/A"}</p>
    <p><strong>State:</strong> {dlData?.state || "N/A"}</p>
    <p><strong>Pin:</strong> {dlData?.permanent_zip || "N/A"}</p>
    <p><strong>Father's Name:</strong> {dlData?.father_or_husband_name || "N/A"}</p>
    <p><strong>Mobile Number:</strong> {dlData?.mobile_number || "N/A"}</p>
    <p><strong>License Number:</strong> {dlData?.license_number || "N/A"}</p>
    <p><strong>Permanent Address:</strong> {dlData?.permanent_address || "N/A"}</p>
  </div>

  {/* Bottom Divider */}
  <div className="border-t-2 border-white mt-1 pt-1 text-center text-xs text-white opacity-80">
    <p>Issued by <strong>{dlData?.state || "State"}</strong> Department of Motor Vehicles</p>
  </div>
</div>


{/* JSON Preview Card */}
<div className="bg-gradient-to-br from-blue-50 to-white border border-blue-200 rounded-2xl shadow-xl p-2 hover:shadow-2xl transition duration-300">
  <h2 className="text-lg font-semibold text-blue-800 mb-1">Dl JSON Data</h2>
  <pre className="bg-gray-100 p-1 rounded text-sm overflow-y-auto max-h-[485px]"> {/* Fixed height set here */}
    {JSON.stringify(dlData, null, 2)}
  </pre>
</div>

      </div>

  )}

    </>
  );
};

export default DLVerify;
